import React, { FC } from 'react';

import { usePlayerViewRef } from '@/scenarios/legacy-player/lib/contexts/view';

import { ClosePlayerButton } from '../../skin/close-player-button/component';
import { BaseControlName } from '../../../types/controls';
import { ContextMenuContainer } from '../../skin/context-menu/container';
import { UserActionIndicatorView } from '../../skin/user-action-indicator/user-action-indicator-view/component';
import { VodKeyboardController } from '../../../../vod-player/ui/VodKeyboardController';
import { UserActionIndicatorProvider } from '../../skin/user-action-indicator/user-action-indicator-provider/component';
import { VodLayout } from '../../../../vod-player/ui/VodLayout';
import { VodPlayButton } from '../../../../vod-player/ui/VodPlayButton';
import { TrailerAgeRestriction } from '../../../../trailer-player/ui/trailer-age-restriction/container';
import { GlobalKeyboardHandlerTogglersProvider } from '../../../contexts/global-keyboard-handler-togglers';
import TrailerPlayerControlPanel from '../trailer-player-control-panel/component';
import { SubtitlesProvider } from '../../subtitles/subtitles-provider/components';
import { SubtitlesPortalRoot } from '../../subtitles/subtitles-portal-root/component';

import styles from './styles.module.css';

interface Props {
    contentId: string;
    onClose?: () => void;
    className?: string;
}
export const TrailerPlayerSkin: FC<Props> = ({ contentId, onClose, className }) => {
    const rootContainerRef = usePlayerViewRef();

    if (!rootContainerRef) {
        return null;
    }

    return (
        <SubtitlesProvider>
            <GlobalKeyboardHandlerTogglersProvider>
                <UserActionIndicatorProvider>
                    <VodKeyboardController onClose={onClose} />
                    <VodLayout
                        className={className}
                        renderTopControls={() => (
                            <ClosePlayerButton
                                name={BaseControlName.CLOSE}
                                onClick={onClose}
                                className={styles.closeButton}
                                contentId={contentId}
                            />
                        )}
                        renderBottomControls={({ setIsHidingControlsBlocked }) => (
                            <div className={styles.controlPanelContainer}>
                                <TrailerPlayerControlPanel
                                    setIsHidingControlsBlocked={setIsHidingControlsBlocked}
                                    contentId={contentId}
                                />
                            </div>
                        )}
                        renderControls={({ isControlsVisible }) => (
                            <>
                                <VodPlayButton className={styles.playButton} />
                                <SubtitlesPortalRoot isControlsVisible={isControlsVisible} />
                                <UserActionIndicatorView className={styles.indicator} />
                                {!isControlsVisible && (
                                    <TrailerAgeRestriction contentId={contentId} />
                                )}
                            </>
                        )}
                        renderPopups={() =>
                            rootContainerRef && (
                                <ContextMenuContainer rootContainerRef={rootContainerRef} />
                            )
                        }
                    />
                </UserActionIndicatorProvider>
            </GlobalKeyboardHandlerTogglersProvider>
        </SubtitlesProvider>
    );
};
